<template>
  <v-container fluid>
    <v-card class="card-rounded">
      <v-card-title>
        <span class="headline">Padrões</span>
        <v-spacer></v-spacer>
        
        <v-btn color="primary" dark @click="incluirPadrao()">Incluir</v-btn>
      </v-card-title>
      <v-card-text>
          <v-data-table
            :key="padroesKey"
            :headers="headersPadroes"
            :items="data"
            :items-per-page="10"
            :loading="loading"
            :no-data-text="
              loading
                ? 'Carregando'
                : 'Nenhum Registro para mostrar'
            "
            class="elevation-1"
          >
            <template v-slot:[`item.numerosPadroes`]="{ item }">
              <span>{{
                numerosConcat(item.numerosPadroes),
              }}</span>
            </template>
          </v-data-table>
         <v-dialog v-model="dialogPadroes" persistent max-width="1200">
          <v-card class="card-rounded">
            <v-form
              @submit.prevent="onSave"
              ref="padroesForm"
              lazy-validation
            >
              <v-card-title>
                Padrões
              </v-card-title>
              <v-card-text>
                <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                  <v-text-field
                    v-model="padrao.descricao"
                    label="Descricao Padrão"
                    required
                  ></v-text-field>
                </v-col>
                <number-selector
                  :key="numberKey"
                  v-model="numeros"
                  :qtde="25"
                ></number-selector>             
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="onClose"
                  >Fechar</v-btn
                >
                <v-btn color="blue darken-1" text @click="onSave" :loading=formLoading>Salvar</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
   
  </v-container>
</template>


<script>
import NumberSelector from "../../components/number-selector.vue";
export default {
  components: {
    "number-selector": NumberSelector,
  },
  data() {
    return {
      data: [],
      dialogPadroes: false,
      padrao: {},
      numberKey: 1,
      numeros: [],
      loading: false,
      formLoading: false,
      padroesKey: 0,
      headersPadroes: [
        {
          text: "Descrição",
          align: "left",
          sortable: true,
          value: "descricao",
        },{
          text: "Números",
          align: "left",
          sortable: true,
          value: "numerosPadroes",
        },
      ],

    }
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      this.$store
        .dispatch("fetchPadroes")
        .then((value) => {
          this.data = value;
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text:
              "Ouve um erro ao carregar os padrões",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    incluirPadrao(){
      this.dialogPadroes = true;
    },
    editarPadrao(padrao){

    },
    excluirPadrao(padrao){

    },
    onSave(){
      this.padrao.numerosPadroes = this.numeros;
      this.formLoading = true;
      this.$store
        .dispatch("savePadroes",this.padrao)
        .then((value) => {
          console.log();
          this.onClose();
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text:
              "Ouve um erro ao carregar os padrões",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClose(){
      this.padrao = {};
      this.dialogPadroes = false;
    },
    numerosConcat(numeros){
      let n = '';
      for(let i = 0; i < numeros.length; i++){
        if (n==''){
          n = i;
        }else{
          n = i+', '+n;
        }
      }
      return n;
    }
  },
}
</script>